var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M8.53 7.47a.75.75 0 0 0-1.06 1.06l1.06-1.06Zm6.94 9.06a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm1.06-8a.75.75 0 0 0-1.06-1.06l1.06 1.06Zm-9.06 6.94a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm0-6.94 8 8 1.06-1.06-8-8-1.06 1.06Zm8-1.06-8 8 1.06 1.06 8-8-1.06-1.06Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;